import React from "react";
import "./footer.scss";
import { ArrowRight, Mail, Phone, Pin } from "../../../icons";
import { Link, useLocation } from "react-router";

const Footer: React.FC = () => {
  const location = useLocation();
  return (
    <footer className="footer">
      {location.pathname !== "/kontakt" && (
        <div className="footer__cta-wrapper">
          <div className="footer__cta">
            <div className="footer__cta-content">
              <h2 className="footer__cta-title">Zapytaj o wycenę</h2>
              <p className="footer__cta-text">
                Skontaktuj się z nami – doradzimy i przygotujemy bezpłatną
                wycenę Twojego projektu.
              </p>
            </div>
            <Link to="/kontakt" className="footer__cta-button">
              <span>Więcej informacji</span>
              <ArrowRight />
            </Link>
          </div>
        </div>
      )}

      <div className="footer__main">
        <div className="footer__container">
          <div className="footer__info-block">
            <div className="footer__info-text-container">
              <span className="footer__info-line"></span>
              <h3 className="footer__info-title">Skontaktuj się z nami</h3>
              <span className="footer__info-line"></span>
            </div>

            <ul className="footer__info-list">
              <li className="footer__info-item">
                <span className="footer__info-icon">
                  <Phone />
                </span>
                <a href="tel:530596229" className="footer__info-link">
                  530 596 229
                </a>
              </li>

              <li className="footer__info-item">
                <span className="footer__info-icon">
                  <Mail />
                </span>
                <a
                  href="mailto:studiowykonczeniowe@gmail.com"
                  className="footer__info-link"
                >
                  studiowykonczeniowe@gmail.com
                </a>
              </li>

              <li className="footer__info-item">
                <span className="footer__info-icon">
                  <Pin />
                </span>
                <span className="footer__info-text">
                  Dębica i okolice do 100km
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright Bottom Bar */}
      <div className="footer__bottom">
        <p>
          © {new Date().getFullYear()} Studio Wykończeniowe Adrian Lada.
          Wszelkie prawa zastrzeżone.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
